<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1>Apracam</h1>
      </div>
      <form @submit.prevent="logar" class="login-form">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            id="email"
            v-model="state.email"
            type="email"
            placeholder="Email:"
            required
          />
        </div>
        <div class="form-group">
          <label for="password">Senha</label>
          <input
            id="password"
            v-model="state.password"
            type="password"
            placeholder="Senha:"
            required
          />
        </div>
        <button type="submit" :disabled="isLoading">
          <span v-if="isLoading">
            Carregando...
            <LoaderIcon class="loader-icon" />
          </span>
          <span v-else>Entrar</span>
        </button>
      </form>
      <div class="login-footer">
        <div class="forgot-password">Centrion Web</div>
      </div>
    </div>
  </div>
  <div id="toast" class="toast">Erro ao fazer login</div>
</template>

<script>
import { reactive } from "vue";
import services from "./../../services";
import { useRouter } from "vue-router";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const state = reactive({
      email: "",
      password: "",
    });
    const router = useRouter();
    const storage = useStorage();
    async function logar() {
      try {
        const { data } = await services.login.logarSistema({
          email: state.email,
          senha: state.password,
        });
        if (data) {
          storage.setStorageSync("token", data.token);
          storage.setStorageSync("nome", data.nome);
          router.push("dashboard");
        }
      } catch (error) {
        const resposta = error && error.response && error.response.data;
        showToast(
          (resposta && (resposta.message || resposta.erro)) ||
            "Não foi possível fazer login. Tente novamente."
        );
      }
    }
    function showToast(message) {
      const toast = document.getElementById("toast");
      toast.textContent = message;
      toast.classList.add("show");
      setTimeout(() => {
        toast.classList.remove("show");
      }, 3000);
    }
    return {
      state,
      logar,
      showToast,
    };
  },
};
</script>
<style scoped>
.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #ff2323;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 10000;
  font-weight: 700;
}

.toast.show {
  opacity: 1;
  transform: translateY(0);
}

#erro {
  background: none;
  position: fixed;
  color: red;
  width: 15rem;
  height: auto;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #16524e;
  font-family: Arial, sans-serif;
}

.login-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  box-shadow: #fff 0px 8px 24px;
}

.login-header {
  background: #16524e;
  padding: 20px;
  text-align: center;
}

.guitar-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
}

.login-header h1 {
  margin: 0;
  font-size: 24px;
  color: #fff;
}

.login-form {
  padding: 20px;
  background-color: #fff;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #16524e;
}

.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #16524e;
  outline: none;
}

.checkbox {
  display: flex;
  align-items: center;
}

.checkbox input {
  margin-right: 5px;
}

button {
  width: 100%;
  padding: 10px;
  background: #16524e;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
}

.login-footer {
  padding: 15px;
  text-align: center;
  background-color: #16524e;
  border-top: 1px solid #16524e;
}

.forgot-password,
.signup-link {
  color: #fff;
  text-decoration: none;
}

.forgot-password:hover,
.signup-link:hover {
  text-decoration: underline;
}

.footer-p {
  color: white;
}

.loader-icon {
  animation: spin 1s linear infinite;
  margin-right: 5px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 480px) {
  .login-card {
    max-width: 100%;
    border-radius: 0;
  }
}
</style>
